import request from '@/router/axios'

// 获取政策公告详情
export function policyAnnouncementDetail(id) {
    return request({
      url: `/api/policy/announcement/${id}`,
      method: 'get'
    })
  }
// 编辑政策公告
export function editPolicyAnnouncement(query) {
    return request({
      url: '/api/policy/announcement',
      method: 'put',
      data: query
    })
  }
// 添加政策公告
export function addPolicyAnnouncement(query) {
    return request({
      url: '/api/policy/announcement',
      method: 'post',
      data: query
    })
  }
  //删除政策公告
  export function deletePolicyAnnouncement(ids) {
    return request({
      url: `/api/policy/announcement/${ids}`,
      method: 'delete'
    })
  }
  // 政策公告分页
  export function policyAnnouncementPage(params) {
    return request({
      url: '/api/policy/announcement/page',
      method: 'get',
      params
    })
  }
  // 上传文件
export function uploadFile(obj) {
    return request({
      url: '/api/blade-resource/oss/endpoint/put-file',
      method: 'post',
      data: obj
    })
  }